import uly from "ulysses/base";
import $ from "jquery";
import ko from "knockout";
import URI from "URI/URI";
import * as d3 from "d3";
import search_utils from "ulysses/widgets/search/utils";
import markup from "./custom_widget_dlg.html";

$(document).ready(function () { $(markup).appendTo($("body")); });

ko.bindingHandlers.sparkpie = {
    init: function (elt, va) {
        $(elt).html(`<input type="text" value="0" class="dial" data-width="80%" data-height="80%" data-readOnly="true" style="display:none">`);
        $(elt).find("input").knob();
        return { controlsDescendantBindings: true };
    },
    update: function (elt, va) {
        $(elt).find("input").val(ko.unwrap(va())).trigger("change");
        //$(elt).sparkline([ko.unwrap(va())], { "type": "pie" });
    }
};

uly.actions.pickwidget = function (e, $elt, ui) {
    var selected_widget = ko.unwrap(ui.model.name);
    ui.context.$parent.widget(selected_widget);
    e.stopPropagation();
    return false;
};

uly.actions.changewidget = function (e, $elt, ui) {
    modify_widget(ui.context.$parent);
    e.stopPropagation();
    return false;
};

function build_widget_model(settings_obs) {
    var model = {
        "index": ko.observable(0),
        "settings": ko.pureComputed(() => {
            var s = ko.unwrap(settings_obs);
            if (!s || !s.type) {
                s = s || {};
                s.type = "custom";
                return s;
            }
            return s;
        })
    };
    var v = model.settings();
    console.log("Got settings obs:", ko.unwrap(settings_obs));
    console.log("Got v:", v);
    model = Object.assign(model, {
        "icon": ko.observable(ko.unwrap(v).icon || "fa-dashboard"),
        "colour": ko.observable(ko.unwrap(v).colour || "default"),
        "value": ko.observable(null),
        "caption": ko.observable(ko.unwrap(v).caption),
        "details_url": ko.observable(null),
        "hardcoded_model": ko.observable(null),
        "local_params": ko.observable(null),
        "name": ko.pureComputed(function () { return ko.unwrap(v).widget; }),
        "search_settings": ko.observable(ko.unwrap(v).search_settings),
        "path": ko.unwrap(v).path,
        "extra_filter": ko.unwrap(v).extra_filter,
        "extra_solr_filter": ko.unwrap(v).extra_solr_filter,
        "override_icon": ko.unwrap(v).override_icon,
        "override_colour": ko.unwrap(v).override_colour,
        "markup": ko.observable(null),
        "data": ko.observable({})
    });
    model.handle_click = (ui) => {
        console.log("Click: ", this, ui, model);
    }
    return model;
}

function get_customwidget_query(widget_model, context, queue) {
    console.log("widget_model:", widget_model);
    console.log("widget name:", ko.unwrap(widget_model.name));
    var dataset = uly.api.start()
        .follow("uly:datasets")
        .follow("find", { "rel": ko.unwrap(widget_model.name) });
    var bound = false;
    var entity = uly.utils.get_bound_resource(context);
    var path = ko.unwrap(widget_model.path);
    var caption = widget_model.caption.peek();
    var icon = widget_model.override_icon;
    var colour = widget_model.override_colour;

    var filter = ko.unwrap(widget_model.extra_filter);
    var solr_filter = ko.unwrap(widget_model.extra_solr_filter);
    if (path) {
        if (entity) {
            dataset = dataset.follow("uly:results", { "origin": entity.unique_id, "path": path, "filter": filter, "solr_filter": solr_filter });
            bound = true;
        }
    }
    if (!bound) {

        dataset = dataset.follow("uly:results", { "filter": filter, "solr_filter": solr_filter });
    }
    dataset._params = {
        "entity": entity,
        "path": path,
        "caption": caption,
        "icon": icon,
        "colour": colour,
        "filter": filter,
        "solr_filter": solr_filter
    };
    return dataset;
}

function load_widget(widget_model, dataset) {
    var caption = dataset._params.caption;
    var icon = dataset._params.icon;
    var colour = dataset._params.colour;
    var path = dataset._params.path;
    var entity = dataset._params.entity;
    return dataset.then(function (result) {
        console.log("Got dataset result:", result);
        widget_model.icon(icon || result.icon);
        widget_model.caption(caption || result.caption || result.title);
        widget_model.colour(colour || result.colour);
        widget_model.details_url(result.details || result.url);
        widget_model.hardcoded_model(result.hardcoded_model);
        widget_model.local_params(result.local_params);
        widget_model.markup(result.markup);
        widget_model.data(result.data);

        var filters = null;
        if (result.details || result.url) {
            //hack to stop the stupid thing interpreting our + as spaces
            var uri = (result.details || result.url).replace("+", "%2B");
            var details_uri = new URI(uri);
            filters = details_uri.query(true).filters;
            if (filters && !Array.isArray(filters))
                filters = [filters];
            else if (!filters)
                filters = [];
            if (path && entity) {
                if (path.indexOf(":") > 0) {
                    path = path.split(":")[1];
                }
                if (path.indexOf(",") > 0) {
                    filters.push(path.split(",").map((p) => "_parents:" + entity.unique_id + "." + p).join(" OR "));
                } else {
                    filters.push("_parents:" + entity.unique_id + "." + path);
                }
                widget_model.search_settings.contextual = true;
            }
            if (details_uri.path() && details_uri.path().indexOf("/") < 0) {
                if (details_uri.path() != "search")
                    filters.push("type:" + details_uri.path());
            }
            if ((filters.length) == 1)
                filters = filters[0];
            else if (filters.length > 0) {
                filters = $.map(filters, function (value) { return "(" + value + ")"; }).join(" AND ");
            }
            else filters = null;

        }
        var settings = ko.unwrap(widget_model.search_settings) || {};
        settings.facets_visible = false;
        settings.local_params = ko.unwrap(widget_model.local_params);
        settings.hardcoded_model = ko.unwrap(widget_model.hardcoded_model);
        if (settings.local_params) {
            filters = settings.local_params + (filters || "");
        }
        console.log("Changing search settigns: result:", result," from:", settings, "filters:", settings.filter, " to:", filters);
        if (settings.filter != filters) {
            settings.filter = filters;
            console.log("Settings search settings load indic:", settings);
            widget_model.search_settings(settings);
        }

        if (result.icon) {
            widget_model.icon(icon || result.icon);
        }

    });

}

ko.bindingHandlers.customwidget = {
    "init": function (elt, va, allbindings, model, context) {

        var widget_data = build_widget_model(va());
        //use parent's observable for search_settings if provided.
        if (allbindings().search_settings) {
            widget_data.search_settings.subscribe((newval) => { allbindings().search_settings(search_utils.ensure_settings_complete(newval)[0]); });// = allbindings().search_settings;
        }
        $(elt).data("custom_widget_data", widget_data);
        $(elt).on("dashboard:refresh", () => {
            widget_data.index.notifySubscribers(widget_data.index());
        });
        var child = context.createChildContext(widget_data);
        ko.applyBindingsToDescendants(child, elt);
        return { controlsDescendantBindings: true };
    },
    "update": function (elt, va, allbindings, model, context) {
        var widget_model = $(elt).data("custom_widget_data");
        var ready = allbindings().ready;
        console.log("loading custom widget");
        //var settings = ko.unwrap(va());
        var queue = ko.unwrap(allbindings().queue);
        var dataset = get_customwidget_query(widget_model, context, queue);
        load_widget(widget_model, dataset).then(() => {
            if (ready) { ready.resolve(true); }
        });
    }
};


export default {
    "select_widget": function select_custom(current_data) {
        var res = Promise.Deferred();
        var cdata = ko.toJS(current_data) || {};
        console.warn("Select Widget:", current_data);
        if (!cdata.type) {
            cdata.type = "custom";
        }

        var editdata = {
            "definition": cdata
        };

        var widgets = uly.api
            .start().follow("uly:datasets")
            .follow("uly:custom")
            .then(function (widgets) {
                if (typeof widgets.length == "undefined") {
                    widgets = [widgets];
                }

                editdata.widgets = widgets;
                console.log("Received widgets:", widgets);
                editdata.widget_filter = ko.observable(null);
                editdata.visible_widgets = ko.pureComputed(() => {
                    var filter = editdata.widget_filter();
                    if (filter == null || filter === "")
                        return widgets;
                    var tokens = filter.toLowerCase().split(" ");
                    var selected = editdata.widget();
                    return widgets.filter((i) => {
                        if (!i) return false;
                        if (!i.name && !i.title)
                            return false;
                        if (i.name == selected || i.title == selected) {
                            return true;
                        }
                        for (let tok_i in tokens) {
                            let tok = tokens[tok_i];
                            if (!tok) continue;
                            if (!(
                                (i.title && i.title.toLowerCase().indexOf(tok) >= 0) ||
                                (i.name && i.name.toLowerCase().indexOf(tok) >= 0)
                            ))
                                return false;
                        }
                        return true;
                    });
                });
                editdata.widget = ko.observable(cdata.name);
                cdata.path = ko.observable(ko.unwrap(cdata.path));
                cdata.caption = ko.observable(ko.unwrap(cdata.caption));
                cdata.extra_filter = ko.observable(ko.unwrap(cdata.extra_filter));
                cdata.extra_solr_filter = ko.observable(ko.unwrap(cdata.extra_solr_filter));
                cdata.override_icon = ko.observable(ko.unwrap(cdata.override_icon));
                cdata.override_colour = ko.observable(ko.unwrap(cdata.override_colour));
                cdata.columns = ko.observable(ko.unwrap(cdata.columns) || 1);
                cdata.widget = ko.observable(ko.unwrap(cdata.widget) || ko.unwrap(cdata.name));
                cdata.get_caption = (v) => {
                    if (ko.unwrap(v.caption)) {
                        return ko.unwrap(v.caption);
                    }
                    if (ko.unwrap(v.widget)) {
                        var i = widgets.filter((i) => { return i.name == ko.unwrap(v.widget) })[0];
                        if (i) {
                            return ko.unwrap(i.title);
                        }
                    }
                    return _("indicator_editor_default_caption", "Undefined");
                }

                var dialog = uly.dialogs.execute($("#custom-widget-picker-tmpl").html(), {
                    "title": _("widget_title_select_indicator", "Select Widget"), raw_data: true
                }, editdata).done(function ([result]) {
                    let cdata = ko.toJS(result.definition);
                    let selected_widget = editdata.widgets.filter((w) => { return w.name == cdata.widget })[0] || {};
                    console.log("Resolving:", selected_widget, cdata);
                    res.resolve([{
                        "path": cdata.path,
                        "caption": cdata.caption,
                        "title": cdata.title,
                        "extra_filter": cdata.extra_filter,
                        "extra_solr_filter": cdata.extra_solr_filter,
                        "override_icon": cdata.override_icon,
                        "override_colour": cdata.override_colour,
                        "columns": cdata.columns,
                        "name": cdata.widget,
                        "widget": cdata.widget
                    }, {
                        "icon": cdata.icon || selected_widget.icon,
                        "colour": cdata.colour || selected_widget.colour,
                        "caption": cdata.caption || selected_widget.caption || selected_widget.title
                    }]);
                }).fail(res.reject);
            },
                function (err) { console.error("Error choosing custom widget.", err); return res.reject(err); });
        return res.promise();
    }
};